import { render, staticRenderFns } from "./gitlab-icon.vue?vue&type=template&id=7844e92d&scoped=true&"
import script from "./gitlab-icon.vue?vue&type=script&lang=js&"
export * from "./gitlab-icon.vue?vue&type=script&lang=js&"
import style0 from "./gitlab-icon.vue?vue&type=style&index=0&id=7844e92d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844e92d",
  null
  
)

component.options.__file = "gitlab-icon.vue"
export default component.exports